import './trusted-security-policies';

import ReactDOM from 'react-dom/client';
import App from './App';
import './assets/i18n/config';
import { installChunkErrorReload } from '@utils/reloadOnChunkError';
import './index.css';
import 'hephaestus/web/assets/index.css';

installChunkErrorReload();

const domRoot = document.getElementById('root');

if (!domRoot) throw new Error('Root element not found.');

const root = ReactDOM.createRoot(domRoot);
root.render(<App />);
